import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderPaper: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-paper"><path fillRule="evenodd" clipRule="evenodd" d="M3 3.75C3 3.33579 3.33579 3 3.75 3H16.25C16.6642 3 17 3.33579 17 3.75V5H20.25C20.6642 5 21 5.33579 21 5.75V10H21.25C21.6642 10 22 10.3358 22 10.75V20.25C22 20.6642 21.6642 21 21.25 21H2.75C2.33579 21 2 20.6642 2 20.25V7.75C2 7.33579 2.33579 7 2.75 7H3V3.75ZM19.5 10V6.5H17V10H19.5ZM15.5 10V4.5H4.5V7H8.75C8.94891 7 9.13968 7.07902 9.28033 7.21967L12.0607 10H15.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFolderPaper;
